<script>
import SpacingOptions from "%/dynamic-components/render-engine/bundles/spacing-options";
import BackgroundOptions from "%/dynamic-components/render-engine/bundles/background-options";
import AppearanceOptions from "%/dynamic-components/render-engine/bundles/appearance-options";
import PositioningOptions from "%/dynamic-components/render-engine/bundles/positioning-options";
import AnimationOptions from "%/dynamic-components/render-engine/bundles/animations-options";
import EffectsOptions from "%/dynamic-components/render-engine/bundles/effects-options";
import LayoutPositionOptions from "%/dynamic-components/render-engine/bundles/layout-position-options";
import AnimationEffectsOptions from "%/dynamic-components/render-engine/bundles/animation-effects-options";
import Container from "%/dynamic-components/render-engine/components/elements/layouts/Container.vue";

export default {
  name: "VerticalContainerWrapper",
  extends: Container,
  elementPanelSettings: {
    alias: "Vertical Container",
    displayName: "Container",
  },
  optionBundles: [
    PositioningOptions,
    new LayoutPositionOptions({
      "default.static-layout-direction": "vertical",
    }),
    new AppearanceOptions({}, {
      "border-radius": false,
    }),
    AnimationOptions,
    AnimationEffectsOptions,
    new EffectsOptions({}, {
      "text-shadow": true,
    }),
    SpacingOptions,
    BackgroundOptions,
  ],
};
</script>
